import React, { useCallback, useMemo, useState } from 'react';
import DatePicker from 'react-datepicker';
import formatDate from 'date-fns/format';
import addDays from 'date-fns/addDays';
import { useIntl } from 'react-intl';
import { Store } from '../../../types/Store';
import { SlotsByDate } from '../../../hooks/useStoreSlots';
import useWizardContext from '../../../hooks/useWizardContext';
import classes from '../classes.module.css';
import TimeslotSelector from './TimeslotSelector';

const today = new Date();

const StoreTimeslots: React.FC<{
  slotsByDate: SlotsByDate;
  store: Store;
}> = ({ store, slotsByDate }) => {
  const intl = useIntl();
  const ctx = useWizardContext();
  const { id } = ctx.appointmentType || {};
  const [date, setDate] = useState(
    Object.keys(slotsByDate).length > 0 ? new Date(Object.keys(slotsByDate)[0]) : new Date(),
  );

  const dateKey = formatDate(date, 'yyyy-MM-dd');
  const filterDate = useCallback(
    (d: Date): boolean => {
      const dd = formatDate(d, 'yyyy-MM-dd');

      return slotsByDate[dd] && slotsByDate[dd].length > 0;
    },
    [slotsByDate],
  );

  const [minDate, maxDate] = useMemo(
    () =>
      Object.keys(slotsByDate).reduce(
        ([min, max], d) => {
          const date = new Date(d);
          return [date < min ? date : min, date > max ? date : max];
        },
        [addDays(today, 100), today],
      ),
    [slotsByDate],
  );

  return slotsByDate && Object.keys(slotsByDate).length > 0 ? (
    <div className={classes.timeslotWrapper}>
      <DatePicker
        minDate={minDate}
        maxDate={maxDate}
        selected={date}
        filterDate={filterDate}
        excludeDate={today}
        onChange={(date) => setDate(date)}
        inline
      />
      <div className={classes.timeslotMessage}>
        {intl.formatMessage({ defaultMessage: ' ', id: 'appointmentTypeSelection.' + id + '.timeslotAgendaText' }) !=
        '-'
          ? intl.formatMessage({ defaultMessage: ' ', id: 'appointmentTypeSelection.' + id + '.timeslotAgendaText' })
          : null}
      </div>
      <TimeslotSelector date={date} slots={slotsByDate[dateKey]} store={store} />
    </div>
  ) : null;
};

StoreTimeslots.displayName = 'StoreTimeslots';

export default StoreTimeslots;
